import { BaseComponent } from '../base-component.js';

export class AgPanelContent extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-panel-content"><slot></slot></div>`;
  }
}

customElements.define('ag-panel-content', AgPanelContent);
